export class LoginCredentials {
  private constructor(
    readonly organizationId: string,
    readonly username: string,
    readonly password: string,
  ) {}

  static init(organizationId: string) {
    return new LoginCredentials(organizationId, '', '');
  }
}
